import React from 'react';

interface TemporaryLayoutProps {
    children: React.ReactNode;
}

export const TemporaryLayout: React.FC<TemporaryLayoutProps> = ({ children }) => {
    return (
        <div className="min-h-screen">
            {children}
        </div>
    );
};